module.exports = __webpack_public_path__ + "img/icon_tab_03.039a8481.svg";